

import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import config from "../../config/config";
import axios from "axios";
import { toast } from "react-toastify";
import { getAuthToken } from "../../utils/token";
import Loader from "../loader/Loader";

const MaterialInspectionReportModalDetails = ({ show, handleClose,materialId }) => {
  const [loading, setLoading] = useState(false);
  const [inspectionreports, setInspectionreports] = useState([]);

  const fetchMaterialinspectionreports = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      setLoading(true);
      const response = await axios.get(
        `${config.API}/manager/materialinspectionreports/${materialId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = response.data;
      if (result?.success === true) {
        setInspectionreports(result.materialnc || []);
      } else {
        setInspectionreports([]);
        console.warn(result?.message || "API success false");
      }
    } catch (err) {
      console.error("Error fetching NC Verification", err);
      toast.error("Failed to fetch inspection report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show, materialId) {
      fetchMaterialinspectionreports();
    }
  }, [show,materialId]);




  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      className="font_family"
    >
   {
    loading ? (
        <Loader/>
    ) :(
           <Modal.Body className="p-5">
        <h4 className="mb-4 fw-bold">Material Inspection Report</h4>

        {/* Material Information */}
        <div className="p-3 border rounded bg-light mb-4">
          <h6 className="fw-semibold">Material Information</h6>
          <Row className="mt-2">
            <Col md={6}>
              <strong>ID:</strong> {inspectionreports?.material_master?.material_code}
            </Col>
            <Col md={6}>
              <strong>Material:</strong> {inspectionreports?.material_master?.material_name}
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <strong>Expected Qty:</strong> {inspectionreports?.material_master?.quantity_in_stock}
            </Col>
            <Col md={6}>
              <strong>Supplier:</strong> {inspectionreports?.supplier_name}
            </Col>
          </Row>
        </div>

        {/* NC Report */}
        <div className="p-3 border rounded bg-light mb-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <Button size="sm" variant="outline-secondary">
              View Full Report
            </Button>
          </div>

          {/* Inspection Checklist */}
          <h6 className="fw-semibold mb-2">Inspection Checklist</h6>
          <Form>
            <Form.Check
              label="Visual Inspection (No visible defects)"
              defaultChecked
            />
            <Form.Check
              label="Dimensional Check (Meets specifications)"
              defaultChecked
            />
            <Form.Check
              label="Quantity Check (Matches delivery note)"
              defaultChecked
            />
            <Form.Check
              label="Packaging Condition (No damage)"
              defaultChecked
            />
            <Form.Check
              label="Material Certificate (Provided and valid)"
              defaultChecked
            />
          </Form>
        </div>

        <Row>
          <Col md={2}></Col>
          <Col md={10}>
            <Form.Group className="mt-4">
              <Row>
                <Col md={2}>
                  <Form.Label>Notes</Form.Label>
                </Col>
                <Col md={10}>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value= {inspectionreports?.notes}
                  />
                </Col>
              </Row>
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
    )
   }

      <Modal.Footer className="border-0">
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MaterialInspectionReportModalDetails;